import { render, staticRenderFns } from "./BeautyConfidentialDataSheet.vue?vue&type=template&id=4b28a366&scoped=true"
import script from "./BeautyConfidentialDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyConfidentialDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BeautyConfidentialDataSheet.vue?vue&type=style&index=0&id=4b28a366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28a366",
  null
  
)

export default component.exports